import styled from 'styled-components';

import NotFoundErrorNotice from './NotFoundErrorNotice';

const TITLE = 'No Features Enabled';

const MESSAGE = `
  Your account does not currently have access to any available features. 
  Please contact support if you believe this is in error or require further assistance.
`;

const StyledErrorNotice = styled(NotFoundErrorNotice)`
  height: 100%;
`;

const NoPermissionErrorNotice = () => {

  return (
    <StyledErrorNotice
      title={TITLE}
      message={MESSAGE}/>
  );
};

export default NoPermissionErrorNotice;
